import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ message = 'جاري التحميل...', overlay = false, size = 'medium' }) => {
  const content = (
    <div className={`loading-spinner-container ${size}`}>
      <div className="modern-loader">
        {/* Center icon */}
        <div className="loader-icon">
          <img src="/assets/icons/icon-512x512.png" alt="Loading" />
        </div>
        
        {/* Animated wave dots */}
        <div className="wave-dots">
          <div className="wave-dot"></div>
          <div className="wave-dot"></div>
          <div className="wave-dot"></div>
          <div className="wave-dot"></div>
          <div className="wave-dot"></div>
        </div>
        
        {/* Pulsing circle effect */}
        <div className="pulse-rings">
          <div className="pulse-ring"></div>
          <div className="pulse-ring"></div>
          <div className="pulse-ring"></div>
        </div>
        
        {/* Rotating gradient border */}
        <div className="gradient-spinner">
          <div className="gradient-inner"></div>
        </div>
      </div>
      
      {message && (
        <div className="loading-message-wrapper">
          <p className="loading-message">{message}</p>
          <div className="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}
    </div>
  );

  if (overlay) {
    return (
      <div className="loading-spinner-overlay">
        {content}
      </div>
    );
  }

  return content;
};

export default LoadingSpinner;

